import { defaultMeta } from "./defaultMeta.constant"

export const defaultTransformerResponse = <T>() => ({ data: [] as T, meta: defaultMeta })
